import React from "react"
import { graphql } from "gatsby"
import LayoutGeneral from "../components/organisms/Layout/LayoutGeneral"
import Seo from "gatsby-plugin-wpgraphql-seo"
import { Helmet } from "react-helmet"
import BannerTerminos from "../components/templates/OthersPage/BannerTerminos"
import getUri from "../helper/getUri"
export const query = graphql`
  query ($id: ID!) {
    wordpress {
      page(id: $id, idType: DATABASE_ID) {
        title
        uri
        seo {
          title
          metaDesc
          focuskw
          metaKeywords
          metaRobotsNoindex
          metaRobotsNofollow
          opengraphTitle
          opengraphDescription
          opengraphImage {
            altText
            sourceUrl
            srcSet
          }
          twitterTitle
          twitterDescription
          twitterImage {
            altText
            sourceUrl
            srcSet
          }
          canonical
          cornerstone
          schema {
            articleType
            pageType
            raw
          }
        }
        template {
          ... on Wordpress_Template_TerminosYCondiciones {
            terminosYCondiciones {
              ...bannerTerminos
            }
          }
        }
      }
    }
  }
`

export default function TerminosCondiciones({ data }) {
  // if(typeof window !== "undefined"){
  //   let bodyHtml = document.querySelector("body");
  //   bodyHtml.classList.remove("no-scroll");
  // }

  const page = data?.wordpress?.page
  const template = page?.template?.terminosYCondiciones
  const pageTitle = page?.title

  return (
    <LayoutGeneral>
      <Helmet>
        <link rel="canonical" href={getUri(page.seo.canonical)} />
      </Helmet>
      <Seo post={page} />
      <h1 className="d-none">{pageTitle}</h1>
      <BannerTerminos
        titulo={pageTitle}
        text={template.texto}
        bgColor={template.colorFondo}
        imagen={template.imagen}
      />
    </LayoutGeneral>
  )
}
